import { MERCHANT_ID, ELEMENT_ID } from './contants';

let friendbuyAPI: { [key: string]: string };

export function initFriendbuy(doc): Promise<void[]> {
  window.friendbuyAPI = friendbuyAPI = window.friendbuyAPI || [];
  friendbuyAPI.merchantId = MERCHANT_ID;
  const friendbuyScriptPromise = new Promise<void>(resolve => {
    createScript(
      doc,
      'friendbuy',
      'https://static.fbot.me/friendbuy.js',
      resolve,
      `${ELEMENT_ID}1`,
    );
  });
  const campaignScriptPromise = new Promise<void>(resolve => {
    createScript(
      doc,
      'campaign',
      'https://campaign.fbot.me/' + friendbuyAPI.merchantId + '/campaigns.js',
      resolve,
      `${ELEMENT_ID}2`,
    );
  });

  return Promise.all([friendbuyScriptPromise, campaignScriptPromise]);
}

function createScript(doc, name, url, onload, elementId) {
  const element = doc.createElement('script');
  element.id = elementId;
  element.async = true;
  element.src = url;
  element.onload = onload;
  doc.head.appendChild(element);
}
